export default __webpack_public_path__ + "static/media/16418216955.1b7a584f.JPG";